import React from 'react';
import { Checkbox } from 'antd';
import cn from 'classnames';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';

type IProps = {
    key?: string | number;
    checked: boolean;
    children?: any;
}

const ThemeCheckBox: React.FC<IProps> = (props) => {

    const {
        children,
        ...rest
    } = props

    return(
        <Checkbox className={styles['checkout-wrap']} {...rest}>
            <div className={cn('flex flex-middle', styles['content-wrap'])}>
                <div className={styles['icons-wrap']}>
                    <Iconfont  className={cn(styles['checked-icon'], 'icon-select2')}/>
                    <Iconfont  className={cn(styles['default-icon'], 'icon-radio-unchecked')}/>
                </div>

                {!!children && (
                    <div className={styles['children-wrap']}>
                        {children}
                    </div>
                )}
            </div>
        </Checkbox>
    );
};

export default ThemeCheckBox